(() => {
  function setupQuickBuy() {
    document.querySelectorAll('[data-quick-buy]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const variants = JSON.parse(panel.querySelector('[data-quick-variants]').textContent);
      const selects = [...panel.querySelectorAll('[data-quick-option]')];
      const form = panel.querySelector('product-form');
      const id = form.querySelector('[name="id"]');
      const button = form.querySelector('[type="submit"]');
      function update() {
        const variant = variants.find(v => !selects.length || selects.every((s,i) => v.options[i] === s.value));
        id.value = variant?.id || '';
        button.disabled = !variant?.available;
        button.querySelector('span').textContent = !variant ? 'Combination unavailable' : variant.available ? 'Add to bag' : 'Sold out';
        panel.querySelector('[data-quick-price]').textContent = variant?.price || 'Choose another option';
        form.handleErrorMessage?.();
        // Keep options selectable so a shopper can change a base before a size.
        // Invalid combinations cannot be submitted.
      }
      panel.addEventListener('change', update);
      panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') { panel.open = false; panel.querySelector('summary').focus(); }
      });
      panel.addEventListener('toggle', () => {
        const summary = panel.querySelector('summary');
        summary.setAttribute('aria-label', (panel.open ? 'Close quick buy for ' : 'Quick buy ') + panel.querySelector('.jb-quick-heading strong').textContent);
        if (panel.open) document.querySelectorAll('[data-quick-buy][open]').forEach(other => { if (other !== panel) other.open = false; });
      });
      update();
    });
  }
  // These are nonmodal card popovers: outside taps and keyboard navigation dismiss them.
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-quick-buy][open]').forEach(panel => {
      if (panel.contains(event.target)) return;
      if (panel.contains(document.activeElement)) panel.querySelector('summary').focus({preventScroll:true});
      panel.open = false;
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-quick-buy][open]').forEach(panel => {
      if (!panel.contains(event.target) && !event.target.closest('cart-drawer')) panel.open = false;
    });
  });
  function setupScratch() {
    const card = document.querySelector('[data-scratch-card]');
    if (!card || card.dataset.ready) return;
    card.dataset.ready = 'true';
    const dialog = card.closest('dialog');
    const canvas = card.querySelector('canvas');
    const ctx = canvas.getContext('2d', {willReadFrequently:true});
    const mitt = card.querySelector('[data-scratch-mitt]');
    let revealed = false, drawing = false, previous, lastCheck = 0;
    function reveal() {
      if (revealed) return;
      const moveFocus = document.activeElement === card;
      revealed = true;
      card.classList.add('is-revealed');
      dialog.classList.add('is-treat-revealed');
      card.querySelector('.jb-scratch-prize').removeAttribute('aria-hidden');
      const after = dialog.querySelector('[data-reveal-actions]');
      card.removeAttribute('tabindex');
      card.removeAttribute('role');
      card.removeAttribute('aria-label');
      after.inert = false;
      after.removeAttribute('aria-hidden');
      dialog.querySelector('[data-reveal-status]').textContent = 'Your offer is revealed. Enter your email to get your discount.';
      // Keyboard activation keeps focus in a visible control.
      if (moveFocus) dialog.querySelector('[data-reveal-actions] input[type="email"]')?.focus({preventScroll:true});
    }
    function paint() {
      if (revealed || !ctx || !card.clientWidth) return;
      const w = card.clientWidth, h = card.clientHeight, ratio = Math.min(devicePixelRatio || 1, 2);
      canvas.width = w * ratio; canvas.height = h * ratio;
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      // An even satin-bronze coating. Avoid discrete marks that read as blotchy tan.
      const gradient = ctx.createLinearGradient(0, 0, w * .35, h);
      gradient.addColorStop(0, '#b68a67');
      gradient.addColorStop(.5, '#ae805e');
      gradient.addColorStop(1, '#a47554');
      ctx.fillStyle = gradient; ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'destination-out';
      // Both the first contact and the following stroke erase at full opacity.
      ctx.fillStyle = '#000'; ctx.strokeStyle = '#000';
      ctx.lineWidth = 65; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    }
    function point(event) {
      const rect = card.getBoundingClientRect();
      return {x:event.clientX-rect.left, y:event.clientY-rect.top};
    }
    function checkProgress(force = false) {
      if ((!force && performance.now()-lastCheck < 100) || !ctx) return;
      lastCheck = performance.now();
      const pixels = ctx.getImageData(0,0,canvas.width,canvas.height).data;
      let empty=0, total=0;
      for (let i=3;i<pixels.length;i+=64) { total++; if(pixels[i]<80) empty++; }
      if (empty / total >= .5) reveal();
    }
    canvas.addEventListener('pointerdown', event => {
      if (revealed || !ctx || event.button > 0) return;
      event.preventDefault(); drawing=true; previous=point(event); canvas.setPointerCapture(event.pointerId);
      card.classList.add('is-wiping', 'has-wiped');
      ctx.beginPath(); ctx.arc(previous.x,previous.y,ctx.lineWidth/2,0,Math.PI*2); ctx.fill();
      mitt.style.left=previous.x+'px'; mitt.style.top=previous.y+'px';
    });
    canvas.addEventListener('pointermove', event => {
      if (!drawing || revealed) return;
      // Preserve intermediate pointer samples on fast swipes instead of cutting corners.
      const samples = event.getCoalescedEvents?.();
      for (const sample of samples?.length ? samples : [event]) {
        const p = point(sample);
        ctx.beginPath(); ctx.moveTo(previous.x,previous.y); ctx.lineTo(p.x,p.y); ctx.stroke(); previous=p;
      }
      mitt.style.left=previous.x+'px'; mitt.style.top=previous.y+'px'; checkProgress();
    });
    const finish = () => { drawing=false; card.classList.remove('is-wiping'); checkProgress(true); };
    canvas.addEventListener('pointerup', finish); canvas.addEventListener('pointercancel', finish);
    card.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      reveal();
    });
    // Assistive technologies activate buttons with a non-pointer click.
    // Ordinary taps/clicks still use the scratch progress threshold.
    card.addEventListener('click', event => { if (event.detail === 0) reveal(); });
    const signupForm = dialog.querySelector('.jb-welcome-signup');
    const response = signupForm?.querySelector('[data-welcome-response]');
    // Only resume this popup for its own native Shopify form response.
    if (response && location.hash === '#' + signupForm.id) {
      reveal();
      dialog.querySelector('[data-reveal-status]').textContent = '';
      const target = response.dataset.welcomeResponse === 'error' ? signupForm.querySelector('input[type="email"]') : response;
      requestAnimationFrame(() => target?.focus({preventScroll:true}));
    }
    new ResizeObserver(paint).observe(card);
    paint();
  }
  setupQuickBuy(); setupScratch();
  document.addEventListener('shopify:section:load', () => { setupQuickBuy(); setupScratch(); });
})();
